import React from "react";
import { LucideIcon } from "./lucide_icon";

// 預設星星icon
const DefaultStar = ({ filled, half, size = 24, color = "#FFD700" }) => {
    if (half) {
        return (
            <span style={{ position: "relative", display: "inline-block", width: size, height: size }}>
                {/* 灰色底星 */}
                <LucideIcon
                    name="Star"
                    size={size}
                    color="#e5e7eb"
                    style={{ position: "absolute", left: 0, top: 0 }}
                />
                {/* 左半金色星 */}
                <span style={{
                    position: "absolute",
                    left: 0,
                    top: 0,
                    width: size / 2,
                    height: size,
                    overflow: "hidden",
                    display: "inline-block"
                }}>
                    <LucideIcon
                        name="Star"
                        size={size}
                        color={color}
                    />
                </span>
            </span>
        );
    }
    return (
        <LucideIcon
            name="Star"
            size={size}
            color={filled ? color : "#e5e7eb"}
        />
    );
};

const StarRating = ({
    value = 0,
    max = 5,
    icon = DefaultStar,
    size = 24,
    color = "#FFD700",
    onChange,
    readOnly = false,
    className = "",
}) => {
    // value 支援 0.5, 1, 1.5, ... max
    const stars = [];
    for (let i = 1; i <= max; i++) {
        let filled = value >= i;
        let half = !filled && value >= i - 0.5;
        stars.push(
            <span
                key={i}
                style={{ cursor: readOnly ? "default" : "pointer", display: "inline-block" }}
                onClick={() => !readOnly && onChange && onChange(i)}
                onMouseMove={e => {
                    if (!readOnly && onChange) {
                        const { left, width } = e.currentTarget.getBoundingClientRect();
                        const x = e.clientX - left;
                        if (x < width / 2) {
                            onChange(i - 0.5);
                        } else {
                            onChange(i);
                        }
                    }
                }}
            >
                {React.createElement(icon, { filled, half, size, color })}
            </span>
        );
    }
    return <div className={className}>{stars}</div>;
};

export default StarRating;
